import { Box, Button, CircularProgress } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../../Redux/hooks";
import { finalizeConsent } from "../../../../Redux/actions/providerConsentAction";
import { useNavigate, useParams } from "react-router-dom";
import { useQuery } from "../../../../utils/hooks";

const Finalize = () => {
  const navigate = useNavigate();
  const { id: consentId } = useParams();
  const versionId = useQuery().get("versionId");
  const studyId = useQuery().get("studyId");
  const epro = useQuery().get("epro");
  const formSubmitting = useAppSelector(
    (state) => state.providerConsent.formSubmitting
  );
  const formStatus = useAppSelector((state) => state.providerConsent.status);
  const editable = formStatus === "not_started" || formStatus === "in_progress";
  const dispatch = useAppDispatch();
  const finalize = async () => {
    const boolean = await dispatch(
      finalizeConsent(studyId || "", consentId, versionId || "")
    );
    if (boolean) {
      if (epro) {
        navigate(-1);
      } else {
        navigate("/participant/e-consent");
      }
    }
  };

  if (!editable) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      {formSubmitting ? (
        <CircularProgress size={25} />
      ) : (
        <Button
          variant="contained"
          onClick={finalize}
          sx={{
            width: { sm: "50%", xs: "100%" },
          }}
        >
          Finalize
        </Button>
      )}
    </Box>
  );
};

export default Finalize;
